import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import { Entry } from '@resolvers/entry'
import React from 'react'

import { type EntryMapper, type References } from './types'

export const entryResolver =
  (references: References, mapping: EntryMapper): NodeRenderer =>
  (node, children) => {
    const entry = references.get(node.data.target.sys.id)
    return (
      <Entry content={entry} mapping={mapping}>
        {children}
      </Entry>
    )
  }
